module.exports = __webpack_public_path__ + "img/Filter.86eac6ac.svg";